import { queries } from "../../shared/queries";
import { useQuery } from "@rocicorp/zero/react";

// Mirrors the server's isSpaceGitSynced (services/shared/mutators/syncGit.ts)
// so the UI never offers an action the server refuses.
export function useIsGitSynced(spaceId: string): boolean {
  const [gitRemote] = useQuery(queries.loadSpaceGitRemote({ spaceId }));
  return gitRemote != null;
}
